import { LayoutDashboard, LogOut, MessageCircle } from 'lucide-react';
import { NavLink, Outlet } from 'react-router';
import { Logo } from '../components/Logo';
import { OfflineBanner } from '../components/OfflineBanner';
import { useAuth } from '../app/authContext';
import { logout } from '../features/auth/api';
import { cn } from '../lib/cn';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    'inline-flex h-10 items-center gap-2 rounded-input px-3 text-sm font-medium',
    isActive ? 'bg-brand-50 text-brand-700' : 'text-slate hover:bg-mist hover:text-ink',
  );

export function TenantLayout() {
  const { profile } = useAuth();
  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-input focus:bg-white focus:px-4 focus:py-2"
      >
        Skip to content
      </a>
      <OfflineBanner />
      <header className="sticky top-0 z-30 border-b border-stone bg-white/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between gap-4 px-4 md:px-6">
          <NavLink to="/app" aria-label="ShenandoahFirst home">
            <Logo className="hidden sm:inline-flex" />
            <Logo showWordmark={false} className="sm:hidden" />
          </NavLink>
          <nav aria-label="Main" className="flex items-center gap-1">
            <NavLink to="/app" end className={linkClass}>
              <LayoutDashboard className="size-4" aria-hidden />
              <span>My tickets</span>
            </NavLink>
            <NavLink to="/app/chat" className={linkClass}>
              <MessageCircle className="size-4" aria-hidden />
              <span>Chat</span>
            </NavLink>
            <button
              type="button"
              onClick={() => void logout()}
              className="inline-flex h-10 items-center gap-2 rounded-input px-3 text-sm font-medium text-slate hover:bg-mist hover:text-ink"
            >
              <LogOut className="size-4" aria-hidden />
              <span className="hidden sm:inline">Sign out</span>
              <span className="sr-only sm:hidden">Sign out</span>
            </button>
          </nav>
        </div>
      </header>
      <main id="main" className="mx-auto w-full max-w-5xl flex-1 px-4 py-6 md:px-6 md:py-8">
        {profile && (
          <p className="mb-1 text-sm text-slate">
            Hello, {profile.name.split(' ')[0]} · Unit{' '}
            <span className="tabular-nums">{profile.unitNumber}</span>
          </p>
        )}
        <Outlet />
      </main>
    </div>
  );
}
